import {Values} from "@wix/devzai-utils-common";

export const DoppeAutoBlogPostType = {
    Latest: 'Latest'
} as const;

export type DoppeAutoBlogPostType = Values<typeof DoppeAutoBlogPostType>;